export default __webpack_public_path__ + "static/media/T45.51914965.JPG";